import { Stack, Typography } from '@mui/material';
import {
	containerStripSX,
	subtitleSX,
	titleSX,
} from '@/components/blocks/DpLibrary/DpStripBenefit/style/main';

export const DpStripBenefit = ({ title, subtitle }: { title: string; subtitle: string }) => (
	<Stack alignItems={'center'} sx={containerStripSX}>
		<Stack sx={{ padding: '11px' }}>
			{title ? (
				<Typography component="h3" sx={titleSX}>
					{' '}
					{title}{' '}
				</Typography>
			) : null}
		</Stack>
		<Stack sx={{ padding: '6px' }}>
			{subtitle ? <Typography sx={subtitleSX}> {subtitle} </Typography> : null}
		</Stack>
	</Stack>
);
